module.exports = __webpack_public_path__ + "img/MTABAPPWL.a283e093.svg";